import QueryString from "query-string";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  fetchAiWalletsSuccess,
  fetchAiWalletsFailure,
  fetchAiLedgerSuccess,
  fetchAiLedgerFailure,
} from "./actions";
import { FETCH_AI_WALLETS, FETCH_AI_LEDGER } from "./constants";

export function* fetchAiWalletsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    // Response body: { data: { location_id, wallets: [...] } }
    const { data } = yield call(api(token).get, `/api/ai-credits?${query}`);
    yield put(fetchAiWalletsSuccess(data));
  } catch (e) {
    yield put(fetchAiWalletsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while fetching AI credit balances!"));
  }
}

export function* fetchAiLedgerSaga({ payload, append = false }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    // Response body: { data: [...rows], meta: {...} }
    const res = yield call(api(token).get, `/api/ai-credits/ledger?${query}`);
    yield put(fetchAiLedgerSuccess(res, append));
  } catch (e) {
    yield put(fetchAiLedgerFailure(null, append));
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while fetching AI credit history!"));
  }
}

export default function* AICreditsSaga() {
  yield all([
    takeLatest(FETCH_AI_WALLETS, fetchAiWalletsSaga),
    takeLatest(FETCH_AI_LEDGER, fetchAiLedgerSaga),
  ]);
}
